export const SpeakerMuteIcon = () => {
    return (<svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.17158 5.41663H0.833252V13.75H5.17158L11.6666 17.5V1.66663L5.17158 5.41663ZM9.99992 4.55342L5.61818 7.08329H2.49992V12.0833H5.61818L9.99992 14.6132V4.55342Z"
            fill="#FCFCFC"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.6916 10.7618L18.8107 12.8809L19.9892 11.7024L17.8701 9.58329L19.9892 7.46422L18.8107 6.2857L16.6916 8.40478L14.5726 6.2857L13.394 7.46422L15.5131 9.58329L13.394 11.7024L14.5726 12.8809L16.6916 10.7618Z"
            fill="#FCFCFC"
        />
    </svg>);
};